import React, { Component } from 'react';

class MixedAnswer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			label: '',
			value: '',
			config: {
				mostBeNum: false,
				numMin: '',
				numMax: '',
				replica: false,
				replicaLabel: ''
			}
		};
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleOnCheck = this.handleOnCheck.bind(this);
		this.handleParentStateCallback = this.handleParentStateCallback.bind(this);
	}
	handleOnChange(e) {
		const { value, name } = e.target;
		const prevState = this.state.config;
		if (name === 'numMin' || name === 'numMax' || name === 'replicaLabel') {
			return this.setState({
				config: {
					...prevState,
					[name]: value
				}
			});
		}
		this.setState({
			[name]: value
		});
	}
	handleOnCheck(e) {
		const { checked: value, name } = e.target;
		const prevState = this.state.config;
		if (name === 'replica' && !value) {
			return this.setState({
				config: {
					...prevState,
					[name]: value,
					mostBeNum: false,
					numMin: '',
					numMax: '',
					replicaLabel: ''
				}
			});
		}
		if (name === 'mostBeNum' && !value) {
			return this.setState({
				config: {
					...prevState,
					[name]: value,
					numMin: '',
					numMax: ''
				}
			});
		}
		this.setState({
			config: {
				...prevState,
				[name]: value
			}
		});
	}
	handleParentStateCallback() {
		this.props.parentStateCallback(this.state);
		this.setState({
			label: '',
			value: '',
			config: {
				mostBeNum: false,
				replica: false,
				numMin: '',
				numMax: '',
				replicaLabel: ''
			}
		});
	}
	renderReplicaLabel() {
		return (
			<div className="row">
				<div className="col-sm-1">
					<div className="form-check">
						<input
							type="checkbox"
							name="replica"
							checked={this.state.config.replica}
							onChange={this.handleOnCheck}
							className="form-check-input"
							id="replica"
						/>
						<label className="form-check-label" htmlFor="replica">
							Réplica
						</label>
					</div>
				</div>
				<div className={this.state.config.replica ? 'col-sm-5' : 'd-none'}>
					<div className="form-group">
						<input
							type="text"
							name="replicaLabel"
							value={this.state.config.replicaLabel}
							onChange={this.handleOnChange}
							className="form-control"
						/>
					</div>
				</div>
			</div>
		);
	}
	renderReplicaNum() {
		return (
			<React.Fragment>
				<hr className={!this.state.config.replica && 'd-none'} />
				<div className={this.state.config.replica ? 'row' : 'd-none'}>
					<div className="col-sm-6">
						<div className="form-group form-check">
							<input
								type="checkbox"
								name="mostBeNum"
								checked={this.state.config.mostBeNum}
								onChange={this.handleOnCheck}
								className="form-check-input"
								id="mostBeNum"
							/>
							<label className="form-check-label" htmlFor="mostBeNum">
								La respuesta debe ser numeral.
							</label>
						</div>
					</div>
				</div>
				<div className={this.state.config.mostBeNum ? 'row' : 'd-none'}>
					<div className="form-check">
						<input
							type="number"
							name="numMin"
							id="numMin"
							placeholder="Mínimo numeral"
							value={this.state.config.numMin}
							onChange={this.handleOnChange}
							className="form-control"
						/>
					</div>
					<div className="form-check">
						<input
							type="number"
							name="numMax"
							id="numMax"
							placeholder="Máximo numeral"
							value={this.state.config.numMax}
							onChange={this.handleOnChange}
							className="form-control"
						/>
					</div>
				</div>
			</React.Fragment>
		);
	}
	render() {
		return (
			<React.Fragment>
				<div className="alert alert-dark">
					<div className="row">
						<div className="col-sm-6">
							<div className="form-group">
								<label>Respuesta</label>
								<input
									type="text"
									name="label"
									value={this.state.label}
									onChange={this.handleOnChange}
									className="form-control"
								/>
							</div>
						</div>
						<div className="col-sm-3">
							<div className="form-group">
								<label>Valor</label>
								<input
									type="text"
									name="value"
									value={this.state.value}
									onChange={this.handleOnChange}
									className="form-control"
								/>
							</div>
						</div>
					</div>
					{this.renderReplicaLabel()}
					{this.renderReplicaNum()}
				</div>

				<button
					onClick={this.handleParentStateCallback}
					className="btn btn-secondary btn-sm"
				>
					Agregar respuesta
				</button>

				<br />
			</React.Fragment>
		);
	}
}

export default MixedAnswer;



// WEBPACK FOOTER //
// ./src/components/Survey/admin/FieldCollection/MixedAnswer.js